import EquipmentSearch from '../../../equipment/services/equipment-search.service';
import { AmAsset } from './models/am-asset.model';
import selectAssetPopupHtml from '../components/asset-list-select-popup/am-assets-list-popup.html';
import selectAssetPopupController from '../components/asset-list-select-popup/am-asset-list-popup';
import { ONEI3_SERVICE_ACCESS_MGMT } from '../../../constants';

export default class AmAssetsService {
  constructor(
    EquipmentService,
    gettext,
    $q,
    $filter,
    $uibModal,
    amFilterPaginationService,
    accessManagementAPI,
  ) {
    'ngInject';

    this.assetAPI = EquipmentService;
    this.gettext = gettext;
    this.$filter = $filter;
    this.$uibModal = $uibModal;
    this.$q = $q;
    this.amFilterPaginationService = amFilterPaginationService;
    this.amAPI = accessManagementAPI;
  }

  getAssetsByFilter(filter, paging = {}) {
    const since = paging.startFrom;
    const limit = paging.pageSize;
    const orderBy = `${filter.orderBy.attr}:${filter.orderBy.desc ? 'desc' : 'asc'}`;
    const sort = [orderBy];
    const apiFilter = EquipmentSearch().buildAPIEquipmentFilterObject(
      filter.queries,
      { since, limit },
      null,
      null,
      filter.facet,
      filter.attrs,
      null,
      null,
      sort,
      null,
    );
    return this.amAPI.getAssetsBySearchFilter(apiFilter).then((response) => {
      const data = response.data || {};
      const assets = (data.data || []).map((asset) => new AmAsset(asset));
      return {
        total: data.total,
        assets,
      };
    });
  }

  openSelectAssetPopup(selected = {}, excluded = []) {
    return this.$uibModal.open({
      animation: true,
      size: 'lg',
      template: selectAssetPopupHtml,
      controller: selectAssetPopupController,
      controllerAs: 'assetPopupVm',
      windowClass: 'tr-am-asset-list-modal-dismiss',
      resolve: {
        selected: () => selected,
        excluded: () => excluded,
      },
    }).result;
  }

  getAssetById(assetId) {
    return this.amAPI.getAssetById(assetId).then((response) => {
      const data = response.data || {};
      const asset = new AmAsset(data);
      return asset;
    });
  }

  getAssetsByGroupId(groupId) {
    return this.amAPI.getAssetsByGroupId(groupId).then((response) => {
      const data = response.data || {};
      const assetsAsModel = data.assets.map((asset) => new AmAsset(asset));
      data.assets = assetsAsModel;
      return data;
    });
  }

  getAssetsByOperatorId(operatorId) {
    return this.amAPI.getAssetsByOperator(operatorId).then((response) => {
      const data = response.data || [];
      const assets = data.map((asset) => new AmAsset(asset));
      return {
        total: data.total,
        assets,
      };
    });
  }
  getPagedAssets(filter, paging = {}, data = [], propertyKeys = []) {
    return this.amFilterPaginationService.getPaged(filter, paging, data, propertyKeys);
  }

  getAssetListByIds(assetIds = []) {
    if (!assetIds.length) return this.$q((resolve) => resolve([]));

    return this.amAPI.getAssetListByIds(assetIds).then((response) => {
      const { data = [] } = response.data || {};
      const assets = data.map((asset) => new AmAsset(asset));
      return {
        total: data.total,
        assets,
      };
    });
  }

  /**
   * @summary Retrieves an array of assets that do not have the onei3 "enabled" tag.
   * @param {any} filter Filtering options to pass to the server
   * @param {any} paging Pagination options to pass to the server
   */
  getAssetsForEnablement(filter = {}, paging = {}) {
    filter = { ...filter };
    filter.queries = [...filter.queries, `NOT ${ONEI3_SERVICE_ACCESS_MGMT}`];
    return this.getAssetsByFilter(filter, paging);
  }

  /**
   * @summary Retrieves an array of assets that do  have the onei3 "enabled" tag.
   * @param {any} filter Filtering options to pass to the server
   * @param {any} paging Pagination options to pass to the server
   */
  getAssetsWithAccessService(filter = {}, paging = {}) {
    filter = { ...filter };
    filter.queries = [...filter.queries, `${ONEI3_SERVICE_ACCESS_MGMT}`];
    return this.getAssetsByFilter(filter, paging);
  }

  /**
   * @summary Submits a list of asset identifiers to the back-end to be enabled
   * @param {number[]} assetIds An array of asset ids to submit for enablement
   * @returns {Promise<any>} A `$q` instance containing a list of successfully enabled IDs and an object containing the failed IDs and an error message
   */
  enableAssets(assetIds = []) {
    return this.amAPI
      .enableAssets(assetIds.filter((id) => id != null && id !== ''))
      .then((response) => response.data);
  }
}
